module.exports = __webpack_public_path__ + "static/media/HelveticaNeue.a035ad37.ttf";